import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const location = useLocation()
	
	// Allow check-in and intake pages even when authenticated (for kiosk/iPad use)
	const publicAccessRoutes = ['/', '/patient-checkin', '/patient-intake']
	const isPublicAccessRoute = publicAccessRoutes.includes(location.pathname)
  
	return token && !isPublicAccessRoute ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet/>
}

export default PublicRoute